import { call, fork, put, take } from 'redux-saga/effects';
import {Action} from 'redux-actions';
import {enqueueErrorSnackbar, enqueueSuccessSnackbar} from '../action/snackbarCommands';
import {getI18n} from 'react-i18next';
import {Api} from '../api';
import Logger from '../common/logger';
import {
    FinishRentalPayload,
    fetchBookingDetails, finishRental,
} from '../action/bookingsCommands';

const onFinishRental = function*(orderId: string, items: string[]) {
    try {
        yield call(Api.finishRental, orderId, items);

        yield put(enqueueSuccessSnackbar({
            message: getI18n().t('snackbar.success.finish_rental'),
        }));

        yield put(fetchBookingDetails({ bookingId: orderId }));
    } catch (e) {
        Logger('Saga').error(e);
        yield put(enqueueErrorSnackbar({
            message: getI18n().t('snackbar.error.finish_rental'),
        }));
    }
};

export function* finishRentalFlow() {
    while (true) {
        const action: Action<FinishRentalPayload> = yield take(finishRental.toString());
        yield fork(onFinishRental, action.payload.orderId, action.payload.items);
    }
}
